import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  cancelButton: {
    color: theme.palette.brand.greenDark,
    border: `2px solid ${theme.palette.brand.greenDark}`,
  },
}));

export default function CancelButton({
  onCancel,
  className = '',
  CancelText = 'Cancel',
  disabled = false,
}) {
  const classes = useStyles();
  return (
    <Button
      className={`${classes.cancelButton} ${className}`}
      onClick={onCancel}
      disabled={disabled}
    >
      {CancelText}
    </Button>
  );
}
